import React, { Component } from "react"
import "./Table.scss";

import TableImg from "./img/Table.svg"

import { withTranslation } from 'react-i18next'

class Table extends Component {
    render() {
        return (
          <ul>
            <li
                id={"Table_"+this.props.id}
                className="Table">
                <img src={TableImg} aria-label={this.props.t('Laboratory shelf')} />
            </li>
          </ul>
        )
    }
}
export default withTranslation()(Table);
